/**
 * ErroIntegracaoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ErroIntegracao} from '@/model/resource/ErroIntegracao'

/* TODO: review generated class */
@HttpExclude()
export class ErroIntegracaoCollection extends PageCollection<ErroIntegracao> {
  constructor() {
    super(ErroIntegracao)
  }

  queryAsPage() {
    return this.listErroIntegracao()
  }

  async listErroIntegracao() {
    return await Request.get(`/admin/erro-integracao`, {params: this.params})
      .name('listErroIntegracao')
      .as(this)
      .getResponse()
  }

  async listCsvErroIntegracao() {
    return await Request.get(`/admin/erro-integracao/csv`, {
      params: this.params,
    })
      .name('listCsvErroIntegracao')
      .as(this)
      .getResponse()
  }
}
